import React from 'react';
import styled from 'styled-components';
import Button from '../../../../components/Button/Button';
import {
  getTextstyle,
  calculateHeight,
  calculateHeightSmallScreen,
  calculateHeightMediumScreen,
  categoriesGradientBorderColor,
  categoriesGradientBackgroundColor,
} from './utils';
import BoxWithBorderGradient from '../../../../components/ContentBox/BoxWithGradientBorder';
import getRewardCenterCategoryMenuIcon from 'shared/screens/RewardCenter/utils/getRewardCenterCategoryMenuIcon';
import { sendRewardCenterEvent } from 'shared/screens/RewardCenter/analytics/rewardCenterlogger';
import { REWARD_CENTER_EVENT_TYPES } from 'shared/screens/RewardCenter/constants';

const RewardCenterCategoriesOpened = props => {
  const {
    categories,
    rewardCenterAssets,
    setFilterData,
    setShowCategories,
    categorySelected,
    setCategorySelected,
    clearFilterData,
  } = props;

  const onClickButton = category => {
    const { categoryId } = category;

    if (categoryId === categorySelected) {
      clearFilterData();
      return;
    }
    setCategorySelected(categoryId);
    setFilterData(categoryId);
    setShowCategories(false);
    sendRewardCenterEvent(REWARD_CENTER_EVENT_TYPES.OPEN_REWARD_CENTER_CATEGORY, { category });
  };

  return (
    <Container>
      <Background
        borderGradient={categoriesGradientBorderColor}
        borderRadius="30"
        borderWidth="3"
        length={categories.length}
      >
        <Header>
          <Arrow src={rewardCenterAssets.REWARD_CENTER_OPENED_MENU_ARROW} />
          <Title src={rewardCenterAssets.REWARD_CENTER_OPENED_MENU_TITLE} />
          <Arrow src={rewardCenterAssets.REWARD_CENTER_OPENED_MENU_ARROW} />
        </Header>
        <Buttons>
          {categories.map(({ categoryId, categoryName, categoryIconType }) => (
            <Button
              key={categoryId}
              label={categoryName}
              imageSource={
                categorySelected === categoryId
                  ? rewardCenterAssets.REWARD_CENTER_OPENED_MENU_BUTTON_ACTIVE
                  : rewardCenterAssets.REWARD_CENTER_OPENED_MENU_BUTTON_DEFAULT
              }
              textStyle={getTextstyle(categoryName, categorySelected, categoryId)}
              buttonIcon={getRewardCenterCategoryMenuIcon({ categoryIconType, rewardCenterAssets })}
              buttonIconStyle={buttonIconStyle}
              imageStyle={buttonStyle}
              containerStyle={buttonContainerStyle}
              onClick={() => onClickButton({ categoryId, categoryName, categoryIconType })}
            />
          ))}
        </Buttons>
      </Background>
    </Container>
  );
};

export default RewardCenterCategoriesOpened;

const Background = styled(BoxWithBorderGradient)`
  position: absolute;
  width: 34rem;
  height: ${({ length }) => calculateHeight(length)}px;
  bottom: 0px;
  z-index: 2;
  background: ${categoriesGradientBackgroundColor};
  border-radius: 30px;

  @media only screen and (max-width: 859px), only screen and (max-height: 520px) {
    width: 22rem;
    border-radius: 20px;
    height: ${({ length }) => calculateHeightSmallScreen(length)}px;
    &:before {
      padding: 2px;
      border-radius: 20px;
    }
  }

  @media only screen and (min-width: 860px) and (max-width: 960px) and (min-height: 521px) {
    width: 30rem;
    border-radius: 25px;
    height: ${({ length }) => calculateHeightMediumScreen(length)}px;
    &:before {
      border-radius: 25px;
    }
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Header = styled.div`
  justify-content: space-around;
  display: flex;
  margin-top: 1rem;
`;

const Title = styled.img`
  width: 45%;
  height: 100%;
  object-fit: contain;
`;

const Arrow = styled.img`
  width: 3%;
  height: 100%;
  object-fit: contain;
`;

const Buttons = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 5% 1.5%;
  display: grid;
  grid-template-columns: repeat(3, 155px);
  justify-content: center;
  gap: 1vw;

  @media (max-width: 859px), (max-height: 520px) {
    grid-template-columns: repeat(3, 92px);
    gap: 8px 6px;
  }

  @media only screen and (min-width: 860px) and (max-width: 960px) {
    grid-template-columns: repeat(3, 135px);
  }
`;

const buttonContainerStyle = `
  width: 155px;
  margin-bottom: 5%;
  @media (max-width: 859px) {
    width: 92px;
  }
  @media only screen and (min-width: 860px) and (max-width: 960px) {
    width: 135px;
  }

  @media (max-height: 520px) {
    width: 92px;
  }
`;

const buttonStyle = `
  width: 155px;
  @media (max-width: 859px) {
    width: 92px;
  }
  @media only screen and (min-width: 860px) and (max-width: 960px) {
    width: 135px;
  }
    @media (max-height: 520px) {
    width: 92px;
  }
`;

const buttonIconStyle = `
  width: 25px;
  height: 25px;
  margin-left: 4px
  margin-right: 4px;
  margin-top: 0;
  object-fit: contain;

  @media (max-width: 859px), (max-height: 520px) {
    width: 12px;
    height: 12px;
    margin-left: 2px
    margin-right: 2px;
  }
  @media only screen and (min-width: 860px) and (max-width: 960px) {
    width: 16px;
    height: 16px;
  }
`;
